export const PRESCRIPTION_LABEL_ROUTE = '/rxlabel';
export const PERSONAL_INFO_ROUTE = '/personal-info';
export const IDENTITY_INFO_ROUTE = '/identity-info';
export const EXTERNAL_IDENTITY_INFO_ROUTE = '/account-lookup/identity-info';
export const ADDRESS_ROUTE = '/demographic';
export const PAGE_NOT_FOUND = '/promo/promoLandingTemplate.jsp?promoLandingId=pagenotfound';
export const CONFIRMATION_ROUTE = '/confirmation';
export const MANAGE_FAMILY_ROUTE = '/account/manage-family';
export const MINOR_CONFIRMATION_ROUTE = '/minorconsent';
export const MFA_ROUTE = '/mfa';
export const RXTIE_ROUTE = '/tie';
export const LEXIS_NEXIS_ROUTE = '/lexis-nexis';
export const LOCKOUT_ROUTE = '/lockout';
export const LOCKED_ROUTE = '/locked';
export const ALREADY_LINKED_ROUTE = '/already-linked';
export const ALREADY_EXISTS_ROUTE = '/already-exists';
export const ERROR_ROUTE = '/error';
//TODO: get default URLs for the caregivee and rxtie apps
export const CAREGIVEE_RETURN_URL = '/';
export const RXTIE_RETURN_URL = '/';
export const CREATE_ACCOUNT_ROUTE = '/account-registration/register/create-account';
export const REGISTRATION_BLOCKED_ROUTE = '/registration-blocked';
export const PHONE_VERIFICATION_ROUTE = '/phone-verification';
export const GUEST_MFA_ROUTE = '/account-auth/mfa';
export const SIGN_IN_ROUTE = '/account-login/look-up';
export const MULTIPLE_MATCHES_ROUTE = '/multiple-matches';
